class Announcement {
	constructor( node ) {
		this.node              = node;
		this.sessionStorageKey = `announcement${ this.node.dataset.key }`;

		if ( ! this.node || sessionStorage.getItem( this.sessionStorageKey ) ) {
			return;
		}

		this.closer  = this.node.querySelector( '.announcement__close' );
		this.display = this.node.dataset.display || 'immediate';
		this.delay   = parseInt( this.node.dataset.delay, 10 ) || 8;
		this.scroll  = parseInt( this.node.dataset.scroll, 10 ) || 30;

		if ( 'immediate' === this.display ) {
			this.open();
		} else if ( 'delay' === this.display ) {
			setTimeout( () => this.open(), this.delay * 1000 );
		} else if ( 'scroll' === this.display ) {
			const onScroll = () => {
				const percentage = Math.round( document.documentElement.scrollTop / document.documentElement.scrollHeight * 100 );

				if ( percentage >= this.scroll ) {
					this.open();
					window.removeEventListener( 'scroll', onScroll );
				}
			}

			window.addEventListener( 'scroll', onScroll );
			onScroll();
		}

		this.closer.addEventListener( 'click', () => this.close() );

		this.node.addEventListener( 'click', (e) => {
			let node = e.target;

			while ( node && node !== this.node ) {
				if ( node.matches( 'a' ) ) {
					this.close();
				}

				node = node.parentNode;
			}
		} );

		// if you've been on the page for a few seconds, you've seen the popup.  No need to show again.
		setTimeout(() => {
			console.log('Time limit reached. No longer showing Global or Premium Announcements.');
			sessionStorage.setItem( this.sessionStorageKey, '1');
		}, 7000);
	}

	open() {
		this.node.removeAttribute( 'hidden' );
		requestAnimationFrame( () => requestAnimationFrame( () => this.node.classList.add( 'announcement--open' ) ) );
	}

	close() {
		const onTransitionEnd = () => {
			this.node.removeEventListener( 'transitionend', onTransitionEnd );
			this.node.parentNode.removeChild( this.node );
		}

		this.node.addEventListener( 'transitionend', onTransitionEnd );
		this.node.classList.remove( 'announcement--open' );
		sessionStorage.setItem( this.sessionStorageKey, '1');
	}
}

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.announcements > .announcement').forEach( node => {
		new Announcement( node );
	})
});
